// ─── Professional color palette (mirrors QuickCom mobile) ─────────────────────
export const PROFESSIONAL_COLORS = {
    turquoise: {main: '#4DB6AC', light: '#80CBC4', dark: '#26A69A', background: '#E0F2F1'},
    // Solid colour per status (dots, legend)
    statusCard: {
        confirmed:  '#2E7D32', // dark green
        pending:    '#E65100', // deep orange
        cancelled:  '#B71C1C', // dark red
        completed:  '#1565C0', // deep blue
    },
};

export const STATUS_OPTIONS = [
    {value: 'confirmed', label: 'Confirmé'},
    {value: 'pending',   label: 'En attente'},
    {value: 'cancelled', label: 'Annulé'},
    {value: 'completed', label: 'Terminé'},
];

// Soft, theme-friendly look per status (light + dark): tinted card, readable
// text, a solid dot and a pill. Literal class names so Tailwind's JIT keeps them.
export const STATUS_STYLES = {
    confirmed: {
        card: 'bg-emerald-50 dark:bg-emerald-500/15 border-emerald-200/80 dark:border-emerald-500/30 text-emerald-950 dark:text-emerald-50',
        pill: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300',
        dot: 'bg-emerald-500',
    },
    pending: {
        card: 'bg-amber-50 dark:bg-amber-500/15 border-amber-200/80 dark:border-amber-500/30 text-amber-950 dark:text-amber-50',
        pill: 'bg-amber-500/15 text-amber-700 dark:text-amber-300',
        dot: 'bg-amber-500',
    },
    cancelled: {
        card: 'bg-rose-50 dark:bg-rose-500/10 border-rose-200/80 dark:border-rose-500/25 text-rose-950/70 dark:text-rose-100/70',
        pill: 'bg-rose-500/15 text-rose-700 dark:text-rose-300',
        dot: 'bg-rose-500',
    },
    completed: {
        card: 'bg-sky-50 dark:bg-sky-500/15 border-sky-200/80 dark:border-sky-500/30 text-sky-950 dark:text-sky-50',
        pill: 'bg-sky-500/15 text-sky-700 dark:text-sky-300',
        dot: 'bg-sky-500',
    },
};

const FALLBACK_STATUS_STYLE = {
    card: 'bg-primary-lighter dark:bg-primary/15 border-primary/30 text-gray-900 dark:text-gray-50',
    pill: 'bg-primary/15 text-primary-dark dark:text-primary',
    dot: 'bg-primary',
};

export const statusStyle = (status) => STATUS_STYLES[status] || FALLBACK_STATUS_STYLE;

export const statusLabel = (status) => STATUS_OPTIONS.find(s => s.value === status)?.label || status;
